// extracted by mini-css-extract-plugin
module.exports = {"item":"jo","dark":"jp","light":"jq","toggle":"jr"};